import { render, staticRenderFns } from "./ModuleQueueList.vue?vue&type=template&id=581efe5d&scoped=true"
import script from "./ModuleQueueList.vue?vue&type=script&lang=js"
export * from "./ModuleQueueList.vue?vue&type=script&lang=js"
import style0 from "./ModuleQueueList.vue?vue&type=style&index=0&id=581efe5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581efe5d",
  null
  
)

export default component.exports